<template>
  <g>
    <path :d="'M' + A.x + ' ' + A.y + ' L' + B.x + ' ' + B.y + ' L' + C.x + ' ' + C.y + ' L' + D.x + ' ' + D.y + ' L' + E.x + ' ' + E.y + ' L' + F.x + ' ' + F.y + ' L' + G.x + ' ' + G.y + 'Z'" stroke="#b1b1b1" stroke-width="1" :fill="material.color.hex"/>
    <g v-for="side in sides" :key="'side-' + side.id">
      <g v-if="side.rand === saum">
        <path :d="side.saum" stroke-width="1" stroke="#b1b1b1" stroke-dasharray="3,3"/>
        <g v-if="side.rand.oesenArt != inactiveOesen">
          <circle v-for="(item, index) in side.oesenAnzahl" :key="index" :cx="side.oesenAbstand.x(index, side.oesenAnzahl)" :cy="side.oesenAbstand.y(index, side.oesenAnzahl)" r="3" stroke="#b1b1b1" stroke-width="2" fill="#fff" />
        </g>
      </g>
      <path v-if="side.rand === hohlsaum" :d="side.hohlsaum" stroke-width="1" stroke="#b1b1b1"/>
    </g>
    <g v-for="(side, index) in sides" :key="index">
      <line :x1="side.border.line.xStart" :y1="side.border.line.yStart" :x2="side.border.line.xEnd" :y2="side.border.line.yEnd" stroke="#353535" stroke-width="1"/>
      <polygon :points="side.border.corner.start" :transform="side.border.corner.rotateStart" stroke="#353535" stroke-width="1" fill="#353535"/>
      <polygon :points="side.border.corner.end" :transform="side.border.corner.rotateEnd" stroke="#353535" stroke-width="1" fill="#353535"/>
    </g>
    <text v-for="side in sides" :key="'label-' + side.id" :x="side.labelSpace.x" :y="side.labelSpace.y" font-weight="bold" font-family="sans-serif" font-size="2.5em" fill="#232323">{{side.name}}</text>
  </g>
</template>

<script>
import DataRand from './../../../../../data/main/config/setup/rand/randArt'

export default {
  props: ['material', 'rand'],
  data () {
    return {
      A: {
        x: 170,
        y: 425
      },
      B: {
        x: 170 - 160 * this.sinCalc(90 * 3 / 7),
        y: 425 - 160 * this.sinCalc(180 * 2 / 7)
      },
      C: {
        x: 170 - 160 * this.sinCalc(90 * 3 / 7) + 160 * this.sinCalc(90 * 1 / 7),
        y: 425 - 160 * this.sinCalc(180 * 2 / 7) - 160 * this.sinCalc(180 * 3 / 7)
      },
      D: {
        x: 170 - 160 * this.sinCalc(90 * 3 / 7) + 160 * this.sinCalc(90 * 1 / 7) + 160 * this.sinCalc(180 * 5 / 14),
        y: 425 - 160 * this.sinCalc(180 * 2 / 7) - 160 * this.sinCalc(180 * 3 / 7) - 160 * this.sinCalc(90 * 2 / 7)
      },
      E: {
        x: 330 + 160 * this.sinCalc(90 * 3 / 7) - 160 * this.sinCalc(90 * 1 / 7),
        y: 425 - 160 * this.sinCalc(180 * 2 / 7) - 160 * this.sinCalc(180 * 3 / 7)
      },
      F: {
        x: 330 + 160 * this.sinCalc(90 * 3 / 7),
        y: 425 - 160 * this.sinCalc(180 * 2 / 7)
      },
      G: {
        x: 330,
        y: 425
      },
      saum: DataRand.randArt.saum.titleSaum.name,
      hohlsaum: DataRand.randArt.hohlsaum.title.name,
      inactiveOesen: DataRand.randArt.saum.optionsOesenart[0].value.oesenArt
    }
  },
  methods: {
    sinCalc (alpha) {
      return Math.sin(alpha * Math.PI / 180)
    }
  },
  computed: {
    sides () {
      return {
        a: {
          name: 'a',
          rand: this.rand.a.type,
          oesenAnzahl: this.rand.a.type === this.saum ? this.rand.a.oesenAnzahl : 0,
          oesenAbstand: {
            xStart: this.A.x + 15 * this.sinCalc(1 / 7 * 180) / this.sinCalc(5 / 14 * 180),
            xEnd: this.G.x - 15 * this.sinCalc(1 / 7 * 180) / this.sinCalc(5 / 14 * 180),
            yConst: this.A.y - 15,
            x: function (i, item) {
              if (item === 1) {
                return (this.xStart + this.xEnd) / 2
              } if (item === 2) {
                return this.xStart + i * (this.xEnd - this.xStart)
              } else {
                return this.xStart + (i / (item - 1)) * (this.xEnd - this.xStart)
              }
            },
            y: function (i, item) {
              return this.yConst
            }
          },
          saum: 'M' + (this.A.x - 30 / this.sinCalc(2 / 7 * 180) * this.sinCalc(3 / 14 * 180)) + ' ' + (this.A.y - 30) + ' L' + (this.G.x + 30 / this.sinCalc(2 / 7 * 180) * this.sinCalc(3 / 14 * 180)) + ' ' + (this.G.y - 30),
          hohlsaum: 'M' + (this.A.x - 9 / this.sinCalc(2 / 7 * 180) * this.sinCalc(3 / 14 * 180)) + ' ' + (this.A.y - 9) + ' L' + (this.G.x + 9 / this.sinCalc(2 / 7 * 180) * this.sinCalc(3 / 14 * 180)) + ' ' + (this.G.y - 9),
          labelSpace: {
            x: 245,
            y: 480
          },
          border: {
            line: {
              xStart: this.A.x,
              yStart: this.A.y + 20,
              xEnd: this.G.x,
              yEnd: this.G.y + 20
            },
            corner: {
              start: this.A.x + ',' + (this.A.y + 20) + ' ' + (this.A.x + 10) + ',' + (this.A.y + 15) + ' ' + (this.A.x + 10) + ',' + (this.A.y + 25),
              rotateStart: 'rotate(0, ' + this.A.x + ', ' + (this.A.y + 20) + ')',
              end: this.G.x + ',' + (this.G.y + 20) + ' ' + (this.G.x - 10) + ',' + (this.G.y + 15) + ' ' + (this.G.x - 10) + ',' + (this.G.y + 25),
              rotateEnd: 'rotate(0, ' + this.G.x + ', ' + (this.G.y + 20) + ')'
            }
          },
          id: 1
        },
        b: {
          name: 'b',
          rand: this.rand.b.type,
          oesenAnzahl: this.rand.b.type === this.saum ? this.rand.b.oesenAnzahl : 0,
          oesenAbstand: {
            xStart: this.A.x + 15 * this.sinCalc(1 / 7 * 180) / this.sinCalc(5 / 14 * 180),
            xEnd: this.B.x + 15 / this.sinCalc(5 / 14 * 180) * this.sinCalc(3 / 7 * 180),
            yStart: this.A.y - 15,
            yEnd: this.B.y - 15 / this.sinCalc(5 / 14 * 180) * this.sinCalc(1 / 14 * 180),
            x: function (i, item) {
              if (item === 1) {
                return (this.xStart + this.xEnd) / 2
              } if (item === 2) {
                return this.xStart + i * (this.xEnd - this.xStart)
              } else {
                return this.xStart + (i / (item - 1)) * (this.xEnd - this.xStart)
              }
            },
            y: function (i, item) {
              if (item === 1) {
                return (this.yStart + this.yEnd) / 2
              } if (item === 2) {
                return this.yStart + i * (this.yEnd - this.yStart)
              } else {
                return this.yStart + (i / (item - 1)) * (this.yEnd - this.yStart)
              }
            }
          },
          saum: 'M' + (this.A.x + 30 / this.sinCalc(2 / 7 * 180)) + ' ' + this.A.y + ' L' + (this.B.x + 30 / this.sinCalc(2 / 7 * 180) * this.sinCalc(1 / 14 * 180)) + ' ' + (this.B.y - 30 / this.sinCalc(2 / 7 * 180) * this.sinCalc(3 / 7 * 180)),
          hohlsaum: 'M' + (this.A.x + 9 / this.sinCalc(2 / 7 * 180)) + ' ' + this.A.y + ' L' + (this.B.x + 9 / this.sinCalc(2 / 7 * 180) * this.sinCalc(1 / 14 * 180)) + ' ' + (this.B.y - 9 / this.sinCalc(2 / 7 * 180) * this.sinCalc(3 / 7 * 180)),
          labelSpace: {
            x: 75,
            y: 400
          },
          border: {
            line: {
              xStart: this.A.x - this.sinCalc(2 / 7 * 180) * 20,
              yStart: this.A.y + this.sinCalc(3 / 14 * 180) * 20,
              xEnd: this.B.x - this.sinCalc(2 / 7 * 180) * 20,
              yEnd: this.B.y + this.sinCalc(3 / 14 * 180) * 20
            },
            corner: {
              start: (this.A.x - this.sinCalc(2 / 7 * 180) * 20) + ',' + (this.A.y + this.sinCalc(3 / 14 * 180) * 20) + ' ' + ((this.A.x - this.sinCalc(2 / 7 * 180) * 20) + 5) + ',' + (this.A.y + this.sinCalc(3 / 14 * 180) * 20 - 10) + ' ' + ((this.A.x - this.sinCalc(2 / 7 * 180) * 20) - 5) + ',' + (this.A.y + this.sinCalc(3 / 14 * 180) * 20 - 10),
              rotateStart: 'rotate(' + ((-3) / 14 * 180) + ', ' + (this.A.x - this.sinCalc(2 / 7 * 180) * 20) + ', ' + (this.A.y + this.sinCalc(3 / 14 * 180) * 20) + ')',
              end: (this.B.x - this.sinCalc(2 / 7 * 180) * 20) + ',' + (this.B.y + this.sinCalc(3 / 14 * 180) * 20) + ' ' + ((this.B.x - this.sinCalc(2 / 7 * 180) * 20) + 5) + ',' + (this.B.y + this.sinCalc(3 / 14 * 180) * 20 + 10) + ' ' + ((this.B.x - this.sinCalc(2 / 7 * 180) * 20) - 5) + ',' + (this.B.y + this.sinCalc(3 / 14 * 180) * 20 + 10),
              rotateEnd: 'rotate(' + ((-3) / 14 * 180) + ', ' + (this.B.x - this.sinCalc(2 / 7 * 180) * 20) + ', ' + (this.B.y + this.sinCalc(3 / 14 * 180) * 20) + ')'
            }
          },
          id: 2
        },
        c: {
          name: 'c',
          rand: this.rand.c.type,
          oesenAnzahl: this.rand.c.type === this.saum ? this.rand.c.oesenAnzahl : 0,
          oesenAbstand: {
            xStart: this.B.x + 15 / this.sinCalc(5 / 14 * 180) * this.sinCalc(3 / 7 * 180),
            xEnd: this.C.x + 15 / this.sinCalc(5 / 14 * 180) * this.sinCalc(2 / 7 * 180),
            yStart: this.B.y - 15 / this.sinCalc(5 / 14 * 180) * this.sinCalc(1 / 14 * 180),
            yEnd: this.C.y + 15 / this.sinCalc(5 / 14 * 180) * this.sinCalc(3 / 14 * 180),
            x: function (i, item) {
              if (item === 1) {
                return (this.xStart + this.xEnd) / 2
              } if (item === 2) {
                return this.xStart + i * (this.xEnd - this.xStart)
              } else {
                return this.xStart + (i / (item - 1)) * (this.xEnd - this.xStart)
              }
            },
            y: function (i, item) {
              if (item === 1) {
                return (this.yStart + this.yEnd) / 2
              } if (item === 2) {
                return this.yStart + i * (this.yEnd - this.yStart)
              } else {
                return this.yStart + (i / (item - 1)) * (this.yEnd - this.yStart)
              }
            }
          },
          saum: 'M' + (this.B.x + 30 / this.sinCalc(2 / 7 * 180) * this.sinCalc(3 / 14 * 180)) + ' ' + (this.B.y + 30 / this.sinCalc(2 / 7 * 180) * this.sinCalc(2 / 7 * 180)) + ' L' + (this.C.x + 30 / this.sinCalc(2 / 7 * 180) * this.sinCalc(5 / 14 * 180)) + ' ' + (this.C.y - 30 / this.sinCalc(2 / 7 * 180) * this.sinCalc(1 / 7 * 180)),
          hohlsaum: 'M' + (this.B.x + 9 / this.sinCalc(2 / 7 * 180) * this.sinCalc(3 / 14 * 180)) + ' ' + (this.B.y + 9 / this.sinCalc(2 / 7 * 180) * this.sinCalc(2 / 7 * 180)) + ' L' + (this.C.x + 9 / this.sinCalc(2 / 7 * 180) * this.sinCalc(5 / 14 * 180)) + ' ' + (this.C.y - 9 / this.sinCalc(2 / 7 * 180) * this.sinCalc(1 / 7 * 180)),
          labelSpace: {
            x: 35,
            y: 215
          },
          border: {
            line: {
              xStart: this.B.x - this.sinCalc(6 / 14 * 180) * 20,
              yStart: this.B.y - this.sinCalc(1 / 14 * 180) * 20,
              xEnd: this.C.x - this.sinCalc(6 / 14 * 180) * 20,
              yEnd: this.C.y - this.sinCalc(1 / 14 * 180) * 20
            },
            corner: {
              start: (this.B.x - this.sinCalc(6 / 14 * 180) * 20) + ',' + (this.B.y - this.sinCalc(1 / 14 * 180) * 20) + ' ' + (this.B.x - this.sinCalc(6 / 14 * 180) * 20 + 5) + ',' + (this.B.y - this.sinCalc(1 / 14 * 180) * 20 - 10) + ' ' + (this.B.x - this.sinCalc(6 / 14 * 180) * 20 - 5) + ',' + (this.B.y - this.sinCalc(1 / 14 * 180) * 20 - 10),
              rotateStart: 'rotate(' + (1 / 14 * 180) + ', ' + (this.B.x - this.sinCalc(6 / 14 * 180) * 20) + ', ' + (this.B.y - this.sinCalc(1 / 14 * 180) * 20) + ')',
              end: (this.C.x - this.sinCalc(6 / 14 * 180) * 20) + ',' + (this.C.y - this.sinCalc(1 / 14 * 180) * 20) + ' ' + (this.C.x - this.sinCalc(6 / 14 * 180) * 20 + 5) + ',' + (this.C.y - this.sinCalc(1 / 14 * 180) * 20 + 10) + ' ' + (this.C.x - this.sinCalc(6 / 14 * 180) * 20 - 5) + ',' + (this.C.y - this.sinCalc(1 / 14 * 180) * 20 + 10),
              rotateEnd: 'rotate(' + (1 / 14 * 180) + ', ' + (this.C.x - this.sinCalc(6 / 14 * 180) * 20) + ', ' + (this.C.y - this.sinCalc(1 / 14 * 180) * 20) + ')'
            }
          },
          id: 3
        },
        d: {
          name: 'd',
          rand: this.rand.d.type,
          oesenAnzahl: this.rand.d.type === this.saum ? this.rand.d.oesenAnzahl : 0,
          oesenAbstand: {
            xStart: this.C.x + 15 / this.sinCalc(5 / 14 * 180) * this.sinCalc(2 / 7 * 180),
            xEnd: this.D.x,
            yStart: this.C.y + 15 / this.sinCalc(5 / 14 * 180) * this.sinCalc(3 / 14 * 180),
            yEnd: this.D.y + 15 / this.sinCalc(5 / 14 * 180),
            x: function (i, item) {
              if (item === 1) {
                return (this.xStart + this.xEnd) / 2
              } if (item === 2) {
                return this.xStart + i * (this.xEnd - this.xStart)
              } else {
                return this.xStart + (i / (item - 1)) * (this.xEnd - this.xStart)
              }
            },
            y: function (i, item) {
              if (item === 1) {
                return (this.yStart + this.yEnd) / 2
              } if (item === 2) {
                return this.yStart + i * (this.yEnd - this.yStart)
              } else {
                return this.yStart + (i / (item - 1)) * (this.yEnd - this.yStart)
              }
            }
          },
          saum: 'M' + (this.C.x - 30 / this.sinCalc(2 / 7 * 180) * this.sinCalc(1 / 14 * 180)) + ' ' + (this.C.y + 30 / this.sinCalc(2 / 7 * 180) * this.sinCalc(3 / 7 * 180)) + ' L' + (this.D.x + 30 / this.sinCalc(2 / 7 * 180) * this.sinCalc(5 / 14 * 180)) + ' ' + (this.D.y + 30 / this.sinCalc(2 / 7 * 180) * this.sinCalc(1 / 7 * 180)),
          hohlsaum: 'M' + (this.C.x - 9 / this.sinCalc(2 / 7 * 180) * this.sinCalc(1 / 14 * 180)) + ' ' + (this.C.y + 9 / this.sinCalc(2 / 7 * 180) * this.sinCalc(3 / 7 * 180)) + ' L' + (this.D.x + 9 / this.sinCalc(2 / 7 * 180) * this.sinCalc(5 / 14 * 180)) + ' ' + (this.D.y + 9 / this.sinCalc(2 / 7 * 180) * this.sinCalc(1 / 7 * 180)),
          labelSpace: {
            x: 145,
            y: 75
          },
          border: {
            line: {
              xStart: this.C.x - this.sinCalc(1 / 7 * 180) * 20,
              yStart: this.C.y - this.sinCalc(5 / 14 * 180) * 20,
              xEnd: this.D.x - this.sinCalc(1 / 7 * 180) * 20,
              yEnd: this.D.y - this.sinCalc(5 / 14 * 180) * 20
            },
            corner: {
              start: (this.C.x - this.sinCalc(1 / 7 * 180) * 20) + ',' + (this.C.y - this.sinCalc(5 / 14 * 180) * 20) + ' ' + (this.C.x - this.sinCalc(1 / 7 * 180) * 20 + 10) + ',' + (this.C.y - this.sinCalc(5 / 14 * 180) * 20 + 5) + ' ' + (this.C.x - this.sinCalc(1 / 7 * 180) * 20 + 10) + ',' + (this.C.y - this.sinCalc(5 / 14 * 180) * 20 - 5),
              rotateStart: 'rotate(' + ((-1) / 7 * 180) + ', ' + (this.C.x - this.sinCalc(1 / 7 * 180) * 20) + ', ' + (this.C.y - this.sinCalc(5 / 14 * 180) * 20) + ')',
              end: (this.D.x - this.sinCalc(1 / 7 * 180) * 20) + ',' + (this.D.y - this.sinCalc(5 / 14 * 180) * 20) + ' ' + (this.D.x - this.sinCalc(1 / 7 * 180) * 20 - 10) + ',' + (this.D.y - this.sinCalc(5 / 14 * 180) * 20 + 5) + ' ' + (this.D.x - this.sinCalc(1 / 7 * 180) * 20 - 10) + ',' + (this.D.y - this.sinCalc(5 / 14 * 180) * 20 - 5),
              rotateEnd: 'rotate(' + ((-1) / 7 * 180) + ', ' + (this.D.x - this.sinCalc(1 / 7 * 180) * 20) + ', ' + (this.D.y - this.sinCalc(5 / 14 * 180) * 20) + ')'
            }
          },
          id: 4
        },
        e: {
          name: 'e',
          rand: this.rand.e.type,
          oesenAnzahl: this.rand.e.type === this.saum ? this.rand.e.oesenAnzahl : 0,
          oesenAbstand: {
            xStart: this.E.x - 15 / this.sinCalc(5 / 14 * 180) * this.sinCalc(2 / 7 * 180),
            xEnd: this.D.x,
            yStart: this.E.y + 15 / this.sinCalc(5 / 14 * 180) * this.sinCalc(3 / 14 * 180),
            yEnd: this.D.y + 15 / this.sinCalc(5 / 14 * 180),
            x: function (i, item) {
              if (item === 1) {
                return (this.xStart + this.xEnd) / 2
              } if (item === 2) {
                return this.xStart + i * (this.xEnd - this.xStart)
              } else {
                return this.xStart + (i / (item - 1)) * (this.xEnd - this.xStart)
              }
            },
            y: function (i, item) {
              if (item === 1) {
                return (this.yStart + this.yEnd) / 2
              } if (item === 2) {
                return this.yStart + i * (this.yEnd - this.yStart)
              } else {
                return this.yStart + (i / (item - 1)) * (this.yEnd - this.yStart)
              }
            }
          },
          saum: 'M' + (this.E.x + 30 / this.sinCalc(2 / 7 * 180) * this.sinCalc(1 / 14 * 180)) + ' ' + (this.E.y + 30 / this.sinCalc(2 / 7 * 180) * this.sinCalc(3 / 7 * 180)) + ' L' + (this.D.x - 30 / this.sinCalc(2 / 7 * 180) * this.sinCalc(5 / 14 * 180)) + ' ' + (this.D.y + 30 / this.sinCalc(2 / 7 * 180) * this.sinCalc(1 / 7 * 180)),
          hohlsaum: 'M' + (this.E.x + 9 / this.sinCalc(2 / 7 * 180) * this.sinCalc(1 / 14 * 180)) + ' ' + (this.E.y + 9 / this.sinCalc(2 / 7 * 180) * this.sinCalc(3 / 7 * 180)) + ' L' + (this.D.x - 9 / this.sinCalc(2 / 7 * 180) * this.sinCalc(5 / 14 * 180)) + ' ' + (this.D.y + 9 / this.sinCalc(2 / 7 * 180) * this.sinCalc(1 / 7 * 180)),
          labelSpace: {
            x: 335,
            y: 75
          },
          border: {
            line: {
              xStart: this.D.x + this.sinCalc(1 / 7 * 180) * 20,
              yStart: this.D.y - this.sinCalc(5 / 14 * 180) * 20,
              xEnd: this.E.x + this.sinCalc(1 / 7 * 180) * 20,
              yEnd: this.E.y - this.sinCalc(5 / 14 * 180) * 20
            },
            corner: {
              start: (this.D.x + this.sinCalc(1 / 7 * 180) * 20) + ',' + (this.D.y - this.sinCalc(5 / 14 * 180) * 20) + ' ' + (this.D.x + this.sinCalc(1 / 7 * 180) * 20 + 10) + ',' + (this.D.y - this.sinCalc(5 / 14 * 180) * 20 + 5) + ' ' + (this.D.x + this.sinCalc(1 / 7 * 180) * 20 + 10) + ',' + (this.D.y - this.sinCalc(5 / 14 * 180) * 20 - 5),
              rotateStart: 'rotate(' + (1 / 7 * 180) + ', ' + (this.D.x + this.sinCalc(1 / 7 * 180) * 20) + ', ' + (this.D.y - this.sinCalc(5 / 14 * 180) * 20) + ')',
              end: (this.E.x + this.sinCalc(1 / 7 * 180) * 20) + ',' + (this.E.y - this.sinCalc(5 / 14 * 180) * 20) + ' ' + (this.E.x + this.sinCalc(1 / 7 * 180) * 20 - 10) + ',' + (this.E.y - this.sinCalc(5 / 14 * 180) * 20 + 5) + ' ' + (this.E.x + this.sinCalc(1 / 7 * 180) * 20 - 10) + ',' + (this.E.y - this.sinCalc(5 / 14 * 180) * 20 - 5),
              rotateEnd: 'rotate(' + (1 / 7 * 180) + ', ' + (this.E.x + this.sinCalc(1 / 7 * 180) * 20) + ', ' + (this.E.y - this.sinCalc(5 / 14 * 180) * 20) + ')'
            }
          },
          id: 5
        },
        f: {
          name: 'f',
          rand: this.rand.f.type,
          oesenAnzahl: this.rand.f.type === this.saum ? this.rand.f.oesenAnzahl : 0,
          oesenAbstand: {
            xStart: this.F.x - 15 / this.sinCalc(5 / 14 * 180) * this.sinCalc(3 / 7 * 180),
            xEnd: this.E.x - 15 / this.sinCalc(5 / 14 * 180) * this.sinCalc(2 / 7 * 180),
            yStart: this.F.y - 15 / this.sinCalc(5 / 14 * 180) * this.sinCalc(1 / 14 * 180),
            yEnd: this.E.y + 15 / this.sinCalc(5 / 14 * 180) * this.sinCalc(3 / 14 * 180),
            x: function (i, item) {
              if (item === 1) {
                return (this.xStart + this.xEnd) / 2
              } if (item === 2) {
                return this.xStart + i * (this.xEnd - this.xStart)
              } else {
                return this.xStart + (i / (item - 1)) * (this.xEnd - this.xStart)
              }
            },
            y: function (i, item) {
              if (item === 1) {
                return (this.yStart + this.yEnd) / 2
              } if (item === 2) {
                return this.yStart + i * (this.yEnd - this.yStart)
              } else {
                return this.yStart + (i / (item - 1)) * (this.yEnd - this.yStart)
              }
            }
          },
          saum: 'M' + (this.F.x - 30 / this.sinCalc(2 / 7 * 180) * this.sinCalc(3 / 14 * 180)) + ' ' + (this.F.y + 30 / this.sinCalc(2 / 7 * 180) * this.sinCalc(2 / 7 * 180)) + ' L' + (this.E.x - 30 / this.sinCalc(2 / 7 * 180) * this.sinCalc(5 / 14 * 180)) + ' ' + (this.E.y - 30 / this.sinCalc(2 / 7 * 180) * this.sinCalc(1 / 7 * 180)),
          hohlsaum: 'M' + (this.F.x - 9 / this.sinCalc(2 / 7 * 180) * this.sinCalc(3 / 14 * 180)) + ' ' + (this.F.y + 9 / this.sinCalc(2 / 7 * 180) * this.sinCalc(2 / 7 * 180)) + ' L' + (this.E.x - 9 / this.sinCalc(2 / 7 * 180) * this.sinCalc(5 / 14 * 180)) + ' ' + (this.E.y - 9 / this.sinCalc(2 / 7 * 180) * this.sinCalc(1 / 7 * 180)),
          labelSpace: {
            x: 445,
            y: 215
          },
          border: {
            line: {
              xStart: this.E.x + this.sinCalc(6 / 14 * 180) * 20,
              yStart: this.E.y - this.sinCalc(1 / 14 * 180) * 20,
              xEnd: this.F.x + this.sinCalc(6 / 14 * 180) * 20,
              yEnd: this.F.y - this.sinCalc(1 / 14 * 180) * 20
            },
            corner: {
              start: (this.E.x + this.sinCalc(6 / 14 * 180) * 20) + ',' + (this.E.y - this.sinCalc(1 / 14 * 180) * 20) + ' ' + (this.E.x + this.sinCalc(6 / 14 * 180) * 20 + 5) + ',' + (this.E.y - this.sinCalc(1 / 14 * 180) * 20 + 10) + ' ' + (this.E.x + this.sinCalc(6 / 14 * 180) * 20 - 5) + ',' + (this.E.y - this.sinCalc(1 / 14 * 180) * 20 + 10),
              rotateStart: 'rotate(' + ((-1) / 14 * 180) + ', ' + (this.E.x + this.sinCalc(6 / 14 * 180) * 20) + ', ' + (this.E.y - this.sinCalc(1 / 14 * 180) * 20) + ')',
              end: (this.F.x + this.sinCalc(6 / 14 * 180) * 20) + ',' + (this.F.y - this.sinCalc(1 / 14 * 180) * 20) + ' ' + (this.F.x + this.sinCalc(6 / 14 * 180) * 20 + 5) + ',' + (this.F.y - this.sinCalc(1 / 14 * 180) * 20 - 10) + ' ' + (this.F.x + this.sinCalc(6 / 14 * 180) * 20 - 5) + ',' + (this.F.y - this.sinCalc(1 / 14 * 180) * 20 - 10),
              rotateEnd: 'rotate(' + ((-1) / 14 * 180) + ', ' + (this.F.x + this.sinCalc(6 / 14 * 180) * 20) + ', ' + (this.F.y - this.sinCalc(1 / 14 * 180) * 20) + ')'
            }
          },
          id: 6
        },
        g: {
          name: 'g',
          rand: this.rand.g.type,
          oesenAnzahl: this.rand.g.type === this.saum ? this.rand.g.oesenAnzahl : 0,
          oesenAbstand: {
            xStart: this.G.x - 15 * this.sinCalc(1 / 7 * 180) / this.sinCalc(5 / 14 * 180),
            xEnd: this.F.x - 15 / this.sinCalc(5 / 14 * 180) * this.sinCalc(3 / 7 * 180),
            yStart: this.G.y - 15,
            yEnd: this.F.y - 15 / this.sinCalc(5 / 14 * 180) * this.sinCalc(1 / 14 * 180),
            x: function (i, item) {
              if (item === 1) {
                return (this.xStart + this.xEnd) / 2
              } if (item === 2) {
                return this.xStart + i * (this.xEnd - this.xStart)
              } else {
                return this.xStart + (i / (item - 1)) * (this.xEnd - this.xStart)
              }
            },
            y: function (i, item) {
              if (item === 1) {
                return (this.yStart + this.yEnd) / 2
              } if (item === 2) {
                return this.yStart + i * (this.yEnd - this.yStart)
              } else {
                return this.yStart + (i / (item - 1)) * (this.yEnd - this.yStart)
              }
            }
          },
          saum: 'M' + (this.G.x - 30 / this.sinCalc(2 / 7 * 180)) + ' ' + this.G.y + ' L' + (this.F.x - 30 / this.sinCalc(2 / 7 * 180) * this.sinCalc(1 / 14 * 180)) + ' ' + (this.F.y - 30 / this.sinCalc(2 / 7 * 180) * this.sinCalc(3 / 7 * 180)),
          hohlsaum: 'M' + (this.G.x - 9 / this.sinCalc(2 / 7 * 180)) + ' ' + this.G.y + ' L' + (this.F.x - 9 / this.sinCalc(2 / 7 * 180) * this.sinCalc(1 / 14 * 180)) + ' ' + (this.F.y - 9 / this.sinCalc(2 / 7 * 180) * this.sinCalc(3 / 7 * 180)),
          labelSpace: {
            x: 405,
            y: 400
          },
          border: {
            line: {
              xStart: this.G.x + this.sinCalc(2 / 7 * 180) * 20,
              yStart: this.G.y + this.sinCalc(3 / 14 * 180) * 20,
              xEnd: this.F.x + this.sinCalc(2 / 7 * 180) * 20,
              yEnd: this.F.y + this.sinCalc(3 / 14 * 180) * 20
            },
            corner: {
              start: (this.G.x + this.sinCalc(2 / 7 * 180) * 20) + ',' + (this.G.y + this.sinCalc(3 / 14 * 180) * 20) + ' ' + ((this.G.x + this.sinCalc(2 / 7 * 180) * 20) + 5) + ',' + (this.G.y + this.sinCalc(3 / 14 * 180) * 20 - 10) + ' ' + ((this.G.x + this.sinCalc(2 / 7 * 180) * 20) - 5) + ',' + (this.G.y + this.sinCalc(3 / 14 * 180) * 20 - 10),
              rotateStart: 'rotate(' + (3 / 14 * 180) + ', ' + (this.G.x + this.sinCalc(2 / 7 * 180) * 20) + ', ' + (this.G.y + this.sinCalc(3 / 14 * 180) * 20) + ')',
              end: (this.F.x + this.sinCalc(2 / 7 * 180) * 20) + ',' + (this.F.y + this.sinCalc(3 / 14 * 180) * 20) + ' ' + ((this.F.x + this.sinCalc(2 / 7 * 180) * 20) + 5) + ',' + (this.F.y + this.sinCalc(3 / 14 * 180) * 20 + 10) + ' ' + ((this.F.x + this.sinCalc(2 / 7 * 180) * 20) - 5) + ',' + (this.F.y + this.sinCalc(3 / 14 * 180) * 20 + 10),
              rotateEnd: 'rotate(' + (3 / 14 * 180) + ', ' + (this.F.x + this.sinCalc(2 / 7 * 180) * 20) + ', ' + (this.F.y + this.sinCalc(3 / 14 * 180) * 20) + ')'
            }
          },
          id: 7
        }
      }
    }
  }
}
</script>

<style>
</style>
